module.exports = __webpack_public_path__ + "img/DSC_1104.cec30019.jpg";